export default "__VITE_ASSET__Dg0HTZIr__"